
import { Calendar, luxonLocalizer } from "react-big-calendar";
import { Messages } from "../Bindings/Feliz.ReactBigCalendar.js";
import React from "react";
import { useTranslation } from "react-i18next";
import { DateTime, Settings } from "luxon";
import { reactApi as reactApi_1, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { utcNow } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";


function getMessages(t, i18n) {
    return new Messages(t("calendar.all_day"), "<", ">", t("calendar.today"), t("calendar.month"), t("calendar.week"), t("calendar.day"), t("calendar.agenda"), t("calendar.date"), t("calendar.time"), t("calendar.event"), t("calendar.no_events_in_range"), (number) => {
        const arg_1 = {
            number: number,
        };
        return i18n.t("calendar.show_more", arg_1);
    });
}

export function BigCalendar(props) {
    let elems, props_1;
    const patternInput = useTranslation();
    Settings.defaultLocale = "de";
    const localizer = luxonLocalizer(DateTime, {
        firstDayOfWeek: 1,
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [(props_1 = ofArray([["key", "tool-reservation-calendar"], ["events", toArray(props.Events)], ["localizer", localizer], ["onSelectEvent", props.OnSelect], ["popup", true], ["endAccessor", "end"], ["messages", getMessages(patternInput[0], patternInput[1])], ["startAccessor", "start"], ["rangeStartMin", utcNow()], ["views", ["month", "week"]], ["getNow", () => ((DateTime.local()).toJSDate())], ["formats", {
        dayFormat: (date, culture, localizer_1) => (localizer_1.format(date, "EEE dd.")),
        dayRangeHeaderFormat: (range, culture_1, localizer_2) => (`${localizer_2.format(range.start, "dd. MMMM")} - ${localizer_2.format(range.end, "dd. MMMM")}`),
    }]]), reactApi.createElement(Calendar, createObj(props_1)))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

